import useElementHeight from 'hooks/useElementHeight';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'shell/components/Button';
import Icon from 'shell/components/Icon';
import Stack from 'shell/components/Stack';
import AssignmentEditorHeaderActions from './AssignmentEditorHeaderActions';

const stickyHeaderStyles = (theme) => {
    const fadeSize = theme.spacing(5);
    const surface = theme.palette.ensightful.shades[0];
    const background = `linear-gradient(to bottom, transparent, ${surface}) 0 0 / 100% ${fadeSize} no-repeat, linear-gradient(to bottom, ${surface} 0, ${surface} calc(100% - ${fadeSize}), transparent 100%)`;

    return {
        position: 'sticky',
        top: fadeSize,
        zIndex: 2,
        isolation: 'isolate',
        background,
        '& > *': {
            position: 'relative',
            zIndex: 1,
        },
        '&::before': {
            content: '""',
            position: 'absolute',
            top: `-${fadeSize}`,
            right: 'var(--assignment-editor-content-negative-padding)',
            bottom: `-${fadeSize}`,
            left: 'var(--assignment-editor-content-negative-padding)',
            background,
            pointerEvents: 'none',
            zIndex: -1,
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            right: 0,
            bottom: `-${fadeSize}`,
            left: 0,
            height: theme.spacing(10),
            background: `linear-gradient(to bottom, ${surface}, transparent)`,
            pointerEvents: 'none',
            zIndex: 0,
        },
    };
};

const AssignmentEditorHeader = ({
    device,
    busy,
    isPersisted,
    publicationAction,
    autosaveStatusContent,
    lastSavedAt,
    onClickBack,
    onClickCancel,
    onClickDelete,
    onAction,
    onHeightChange,
}) => {
    const { t } = useTranslation('assignmentSettings');
    const { elementRef, height } = useElementHeight();

    useEffect(() => {
        onHeightChange?.(height);
    }, [height, onHeightChange]);

    return (
        <Stack
            ref={elementRef}
            direction={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
            useFlexGap
            flexWrap={'wrap'}
            spacing={3}
            sx={stickyHeaderStyles}
        >
            <Button
                variant={'borderless'}
                startIcon={<Icon kind={'arrowLeft'} />}
                onClick={onClickBack}
                disabled={busy}
            >
                {t('common:controls.back', 'Back')}
            </Button>
            <AssignmentEditorHeaderActions
                device={device}
                busy={busy}
                isPersisted={isPersisted}
                publicationAction={publicationAction}
                autosaveStatusContent={autosaveStatusContent}
                lastSavedAt={lastSavedAt}
                onClickCancel={onClickCancel}
                onClickDelete={onClickDelete}
                onAction={onAction}
            />
        </Stack>
    );
};

export default AssignmentEditorHeader;
